import { isEmpty } from "@ember/utils";
import { isTesting } from "discourse-common/config/environment";
import getURL from "discourse-common/lib/get-url";
import { helperContext } from "discourse-common/lib/helpers";
export default function logout() {
  let {
    redirect
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (isTesting()) {
    return;
  }
  const ctx = helperContext();
  let keyValueStore = ctx.keyValueStore;
  keyValueStore.abandonLocal();
  if (!isEmpty(redirect)) {
    window.location.href = redirect;
    return;
  }
  const url = ctx.siteSettings.login_required ? "/login" : "/";
  window.location.href = getURL(url);
}